export default __webpack_public_path__ + "static/media/full-screen-image-2.e2e1e456.jpg";